import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import styles from "./imageslider.module.scss";
import { SonicTermData } from "../../common/classes/SonicTerm";

type Props = {
  img?: Array<string> | Array<File>;
  type?: SonicTermData;
};

export const ImageSlider: React.FC<Props> = (props) => {
  const { img, type } = props;
  const [count, setCount] = useState(1);
  let length: number = 0;

  if (img !== undefined) {
    length = img.length;
  }

  const type_color = type?.color ? type.color : "#D89529";
  const type_shadow = type?.color ? `${type.color} 0 0 4px` : `#D89529 0 0 4px`;

  const nextOnClick = () => {
    if (count !== length) {
      setCount(count + 1);
    } else {
      setCount(1);
    }
  };

  const prevOnClick = () => {
    if (count !== 1) {
      setCount(count - 1);
    } else {
      setCount(length);
    }
  };

  const getCurrentImageUrl = () => {
    const img_data = img?.[count - 1];

    if (img_data) {
      return typeof img_data === "string"
        ? img_data
        : URL.createObjectURL(img_data);
    } else {
      return "";
    }
  };

  return (
    <>
      {img ? (
        <div className={styles["slider"]}>
          <div className={styles["slider_img"]}>
            {typeof img[count - 1] === "string" ? (
              <img src={img[count - 1] as string} />
            ) : (
              <img src={getCurrentImageUrl()} />
            )}
          </div>
          <div className={styles["slider_round-button"]}>
            <span
              onClick={() => prevOnClick()}
              style={{
                color: type_color,
                filter: `drop-shadow(0 0 4px ${type_color})`,
              }}
              data-testid="chevron-icon-l"
            >
              <FontAwesomeIcon icon={["fal", "chevron-left"]} />
            </span>
            {img.map((value: string | File, index: number) => {
              if (index + 1 == count) {
                return (
                  <div
                    key={index}
                    className={styles["slider_round-button_now"]}
                    style={{
                      backgroundColor: type_color,
                      boxShadow: `${type_shadow}, #fff 0 0 6px inset`,
                    }}
                    data-testid="type-dots"
                    onClick={() => {
                      setCount(index + 1);
                    }}
                  ></div>
                );
              } else {
                return (
                  <div
                    key={index}
                    className={styles["slider_round-button_img-link"]}
                    onClick={() => {
                      setCount(index + 1);
                    }}
                  ></div>
                );
              }
            })}
            <span
              onClick={() => nextOnClick()}
              style={{
                color: type_color,
                filter: `drop-shadow(0 0 4px ${type_color})`,
              }}
              data-testid="chevron-icon-r"
            >
              <FontAwesomeIcon icon={["fal", "chevron-right"]} />
            </span>
          </div>
        </div>
      ) : null}
    </>
  );
};

export default ImageSlider;
